module.exports = __webpack_public_path__ + "static/media/logo.1845483b.png";